import { render, staticRenderFns } from "./AppBarMenuUser.vue?vue&type=template&id=b5065754&"
import script from "./AppBarMenuUser.vue?vue&type=script&lang=js&"
export * from "./AppBarMenuUser.vue?vue&type=script&lang=js&"
import style0 from "./AppBarMenuUser.vue?vue&type=style&index=0&id=b5065754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports